import * as React from "react";
import { IFGMultiCheckboxInputProps, FGMultiCheckboxInput } from "nsitools-react";
import { Colors } from "@blueprintjs/core";

export interface IFGSRSHMultiCheckboxInputProps extends IFGMultiCheckboxInputProps {}

export const FGSRSHMultiCheckboxInput: React.FunctionComponent<IFGSRSHMultiCheckboxInputProps> = ({
  colorTick = Colors.GREEN5,
  colorCross = Colors.RED5,
  ...mcProps
}) => {
  return <FGMultiCheckboxInput {...mcProps} colorTick={colorTick} colorCross={colorCross} />;
};
